<template>
    <section class="sales-brands-info-section" style="padding-top: 4rem;" v-if="likeBrandsList.length">
        <div class="section-inner">
            <h2 class="heading-section"><span>Sales Brands Info</span></h2>

            <div class="card_like-us">
                <swiper
                    :slides-per-view="5.1"
                    :space-between="30"
                    :grabCursor="true"
                    :speed="500"
                >
                    <swiper-slide v-for="brand in likeBrandsList">
                        <a v-if="pageType == 2" :href="route('brand_detail', brand.id)" class=""><span>MORE</span></a>
                        <a v-if="pageType != 2" class=""><span>MORE</span></a>
                        <img v-bind:src="this.$store.state.const.AWS_S3_URL_HOST + brand.logo" alt="">
                        <div class="detail">
                            <h5>{{brand.name}}</h5>
                        </div>
                    </swiper-slide>
                </swiper>
            </div>
        </div><!--/.section-inner-->
    </section>

    <!-- <button v-if="$store.state.detail.set.basicAndShowRoom" v-on:click="openModal()" v-bind:disabled="disableModal">申請するボタン</button> -->
    <section class="my-select-room-add" style="padding-top: 2rem;" v-if="$store.state.detail.set.basicAndShowRoom">
        <div class="section-inner">
            <div class="item-wrap">
                <div class="action-btn-wrap form_hashtag">
                    <!--MySelectRoomBtn-->
                    <input
                        type="checkbox"
                        name="add-my-select-room-preview"
                        id="sales_brands_info1"
                        value=""
                        v-on:click="openModal()"
                        v-bind:disabled="disableModal"
                    >
                    <label for="sales_brands_info1" class="btn_common _ghost _home-add">
                        <div class="md_svg-icon">
                            <SvgIconAdd />
                        </div>
                        <span class="">申請する</span>
                    </label>

                </div><!--/.action-btn-wrap-->
            </div>
        </div>
    </section><!--/.page-name-row-->

    <!--:::::::::::::::::::::::::::::::::::::::::::::::
        ModalMySelectRoomCheckList
    :::::::::::::::::::::::::::::::::::::::::::::::::-->
    <div class="modal_container MySelectRoomCheckList" v-bind:class="{_open: isOpen}">
        <div class="wrap">
            <!-- Title -->
            <div class="title">
                <h3><span>申請するブランドを選択してください</span></h3>
            </div><!-- /.Title -->
            <!-- Text -->
            <div class="text-wrap">
                <div class="inner">

                    <ul class="list_common _full" v-for="(brand, index) in modalList" v-bind:key="index" >
                        <li class="item form_checkbox _all">
                            <input
                                type="checkbox"
                                name="my-select-room-add"
                                v-bind:id="'my-select-room-add' + index + 1"
                                v-bind:checked="brand.sales_brand_status"
                                v-on:change="setSalesBrand(brand)"
                            >
                            <label v-bind:for="'my-select-room-add' + index + 1">
                                <div class="check-mark"><span></span></div>
                                <span>{{ brand.name }}</span>
                                <span v-if="brand.sales_brand_status == 1"> 申請済</span>
                            </label>
                        </li>
                    </ul>

                    <!-- Button -->
                    <div class="button-wrap">
                        <button type="button" class="cancel" v-on:click="closeModal"><span>キャンセル</span></button>
                        <button type="button" v-on:click="saveSalesBrand"><span>申請</span></button>
                    </div><!-- /.button-wrap -->

                </div><!-- /.Inner -->
            </div><!-- /.Text -->
            <div class="close-icon"><span></span><span></span></div>
        </div><!-- /.Wrap -->
        <div class="modal_close-ovl" v-on:click="closeModal"></div>
    </div><!-- /.ModalContainer -->
    <!--:::::::::::::::::::::::::::::::::::::::::::::::
        ModalBackGround
    :::::::::::::::::::::::::::::::::::::::::::::::::-->
    <div class="modal_bg" v-bind:class="{_on: isOpen}"></div>
</template>

<script>
    //Swiper.js
    import { Swiper, SwiperSlide } from 'swiper/vue';
    import 'swiper/css';

    //Swiper.js - css
    import "swiper/css/pagination"
    import "swiper/css/navigation"

    import SvgIconAdd from '@/components/EndUser/svg/SvgIconAdd'

    //SwiperModules
    import SwiperCore, {
        Autoplay,
        Pagination,
        Navigation
    } from 'swiper';
    SwiperCore.use([
        Autoplay,
        Pagination,
        Navigation
    ]);

    export default {
        components: {
            //Swiper.js
            Swiper,
            SwiperSlide,
            SvgIconAdd
        },
        props: {
            likeBrands: Object,
        },
        emits: ['openAlertModal'],
        data() {
            return {
                isOpen: false,
                brandsData: [],
            };
        },
        mounted() {
            if (this.$store.state.register.set.sales_brands) {
                this.brandsData = this.$store.state.register.set.sales_brands.filter((sales_brand) => {
                    return (sales_brand.sales_brand_status == 1);
                });
            }
        },
        methods: {
            setSalesBrand(brand) {
                var brandIndex = '';
                var brandCheck = true;

                this.brandsData.forEach(function(brandData, index) {
                    if (brandData.id == brand.id) {
                        brandIndex = index;
                        brandCheck = false;
                    }
                });

                if (!brandCheck){
                    this.brandsData.splice(brandIndex, 1)
                } else {
                    this.brandsData.push(brand)
                }
            },
            saveSalesBrand() {
                axios.post(route('set.salesBrand'), {
                    brandId: this.$store.state.detail.set.brand.id,
                    salesBrands: this.brandsData,
                }).then((res) => {
                    location.reload();
                    this.closeModal();
                }).catch((error) => {
                    if (error.response.status == 401) {
                        location.href = '/login' + '?before';
                    }
                });
            },
            openModal() {
                if (!this.$store.state.detail.set.user || this.$store.state.detail.set.user.length == 0) {
                    return location.href = '/login' + '?before';
                } else {
                    this.isOpen = true;
                }
            },
            closeModal() {
                this.isOpen = false;
            },
        },
        computed: {
            modalList() {
                if (this.$store.state.register.set.sales_brands) {
                    return this.$store.state.register.set.sales_brands;
                }
            },
            likeBrandsList() {
                if(this.$store.state.detail.set.brand.sales_brands) {
                    var list = [];
                    for (var i in this.$store.state.detail.set.brand.sales_brands) {
                        if (this.$store.state.detail.set.brand.sales_brands[i].brand_images[0]) {
                            this.$store.state.detail.set.brand.sales_brands[i].logo =  this.$store.state.detail.set.brand.sales_brands[i].brand_images[0].path;
                            list.push(this.$store.state.detail.set.brand.sales_brands[i]);
                        }
                    }

                    // this.$store.state.register.form.sales_brands = this.$store.state.detail.set.brand.sales_brands;
                    return list;
                } else {
                    return 0;
                }
            },
            pageType() {
                var url = location.pathname;
                if (url.indexOf( 'registration' ) != -1) {
                    //初回編集
                    return 0;
                } else if (url.indexOf( '/detail' ) != -1) {
                    if (this.brand || this.shop) {
                        //管理画面での編集
                        return 1;
                    } else {
                        //管理画面での新規追加
                        return 3;
                    }
                } else {
                    //エンドユーザー側での表示
                    return 2;
                }
            },
            disableModal() {
                var url = location.pathname;
                if (url.indexOf( '/demo/' ) != -1) {
                    return true;
                }
                if (url.indexOf( '/detail' ) != -1) {
                    return true;
                } else {
                    return false;
                }
            },
        }
    }
</script>
